// function FormatCardNumber(cardNumber) {
//   const formatPattern = /(\d{4})(\d{4})(\d{4})(\d{4})/;

//   const formattedNumber = cardNumber.replace(formatPattern, "$1 $2 $3 $4");

//   return formattedNumber;
// }

// export default FormatCardNumber;


function FormatCardNumber(cardNumber) {
  if (!cardNumber) return "";

  // Remove any existing spaces from the input
  const cleanedNumber = cardNumber.replace(/\s+/g, "");

  // Add spaces after every 4 digits
  const formattedNumber = cleanedNumber
    .match(/.{1,4}/g) // Split into groups of up to 4 characters
    ?.join(" ") || ""; // Join with spaces, or return an empty string if no match

  return formattedNumber;
}

export default FormatCardNumber;
